<template>
  <UIContentBox
    class="flex justify-between mx-4"
    :style="{ width: 'auto' }"
  >
    <BackButton
      v-if="isBackButtonVisible"
      :disabled="isLoading"
      @click="backClick"
    />

    <div class="flex gap-4 ml-auto">
      <slot name="before-save"></slot>
      <Button
        type="primary"
        :text="submitBtnLabelTranslated"
        :loader="isLoading"
        :disabled="isLoading || $attrs.disabled"
        @click="nextClick"
      />
    </div>
  </UIContentBox>
</template>

<script>
import Button from "@shared/components/button";
import BackButton from "./BackButton";

export default {
  name: "FormBuilderNavBar",
  props: {
    submitBtnLabel: String, 
    hideActions: {
      type: Array,
      default: () => [],
    },
    // forces the back button to be shown even if hideActions includes 'back'
    showBackButton: {
      type: Boolean,
      default: false,
    },
  }, 

  components: {
    Button,
    BackButton,
  },

  computed: {
    submitBtnLabelTranslated() {
      return this.submitBtnLabel || this.$t('actions.save_and_next')
    }, 
    isBackButtonVisible() {
      const isVisible = !this.hideActions.includes('back');
      return (isVisible && this.fbProps.isBackButtonVisible) || this.showBackButton;
    },
    isUsedFormBuilderSubmitMethod() {
      return this.fbProps.isUsedFormBuilderSubmitMethod;
    },
    isLoading() {
      return this.fbProps.isLoading;
    },
    fbProps() {
      return this.$attrs.data;
    },
    readonly(){
      return this.fbProps.isReadOnlyMode
    }
  },

  methods: {
    async nextClick() {
      if (this.isUsedFormBuilderSubmitMethod) {
        await this.fbProps.saveForm();
        if(!this.readonly){
          this.$emit("submitEntityForm");
        }
      } else {
        await this.fbProps.nextSection();
      }
    },

    async backClick() {
      const prevSectionData = await this.fbProps.prevSection();
      if (!prevSectionData) return;

      this.$emit("back", prevSectionData);
    },
  }
}
</script>
